export default "__VITE_ASSET__qbgJnW36p7qWmSFg4IZ0eQ__"